import { FrameName, tilerepoGrasslandFrameNames } from "@/game/entities/config";

/*export const CHEST_CONFIG = {
	ALLOWED_ON_EXPLORED: new Set<FrameName>([
		FrameName.SHALLOW_SEA,
		FrameName.DEEP_SEA,
		...tilerepoGrasslandFrameNames,
		FrameName.FOREST,
		FrameName.DENSE_FOREST,
		FrameName.OLD_FOREST,
	]),
	EXPLORATION: {
		DIST_MIN: 8,
		DIST_MAX: 14,
		SCAN_RADIUS: 12,
	},
	RETURN: {
		NEIGHBOR_DIRECTIONS: [
			[-1, 0],
			[1, 0],
			[0, -1],
			[0, 1],
			[-1, -1],
			[-1, 1],
			[1, -1],
			[1, 1],
		],
		SCAN_STEP: 10,
	},
	CHEST_LIMIT: 3,
	SPECIAL_CHEST: {
		CHANCE: 0.2,
		COOLDOWN_MS: 6 * 60 * 60 * 1_000,
	},
	REWARD: {
		BASE: 10000,
		SPECIAL_BASE: 40000,
		PASSIVE_INCOME_MULTIPLIER: 8,
		SPECIAL_PASSIVE_INCOME_MULTIPLIER: 50,
		UPGRADE_BONUS: 1.0,
		SPECIAL_UPGRADE_BONUS: 1.2,
		RAND_MIN: 1,
		RAND_MAX: 1.2,
		SUPER_CLICKERS_CHANCE: 0.4,
		SUPER_CLICKERS_MIN: 5,
		SUPER_CLICKERS_MAX: 7,
		SPECIAL_SUPER_CLICKERS_MIN: 20,
		SPECIAL_SUPER_CLICKERS_MAX: 25,
		SPECIAL_GEMS_MIN: 8,
		SPECIAL_GEMS_MAX: 12,
	},
	EXPLORATION_CHEST_BASE: 30,
	EXPLORATION_CHEST_INCREMENT: 35,
};
 */

export const CHEST_CONFIG_A = {
	ALLOWED_ON_EXPLORED: new Set<FrameName>([
		FrameName.SHALLOW_SEA,
		FrameName.DEEP_SEA,
		...tilerepoGrasslandFrameNames,
		FrameName.FOREST,
		FrameName.DENSE_FOREST,
		FrameName.OLD_FOREST,
	]),
	EXPLORATION: {
		DIST_MIN: 8,
		DIST_MAX: 14,
		SCAN_RADIUS: 12,
	},
	RETURN: {
		NEIGHBOR_DIRECTIONS: [
			[-1, 0],
			[1, 0],
			[0, -1],
			[0, 1],
			[-1, -1],
			[-1, 1],
			[1, -1],
			[1, 1],
		],
		SCAN_STEP: 10,
	},
	CHEST_LIMIT: 3,
	SPECIAL_CHEST: {
		CHANCE: 0.2,
		COOLDOWN_MS: 6 * 60 * 60 * 1_000,
	},
	REWARD: {
		BASE: 10000,
		SPECIAL_BASE: 40000,
		PASSIVE_INCOME_MULTIPLIER: 8,
		SPECIAL_PASSIVE_INCOME_MULTIPLIER: 50,
		UPGRADE_BONUS: 1.0,
		SPECIAL_UPGRADE_BONUS: 1.2,
		RAND_MIN: 1,
		RAND_MAX: 1.2,
		SUPER_CLICKERS_CHANCE: 0.4,
		SUPER_CLICKERS_MIN: 5,
		SUPER_CLICKERS_MAX: 7,
		SPECIAL_SUPER_CLICKERS_MIN: 20,
		SPECIAL_SUPER_CLICKERS_MAX: 25,
		SPECIAL_GEMS_MIN: 8,
		SPECIAL_GEMS_MAX: 12,
	},
	EXPLORATION_CHEST_BASE: 30,
	EXPLORATION_CHEST_INCREMENT: 35,
};

export const CHEST_CONFIG_B = {
	...CHEST_CONFIG_A,
	CHEST_LIMIT: 3,
	SPECIAL_CHEST: {
		CHANCE: 0.35,
		COOLDOWN_MS: 1 * 60 * 60 * 1_000, // 1 hours
	},
	REWARD: {
		BASE: 10000,
		SPECIAL_BASE: 50000,
		PASSIVE_INCOME_MULTIPLIER: 8,
		SPECIAL_PASSIVE_INCOME_MULTIPLIER: 40,
		UPGRADE_BONUS: 1.0,
		SPECIAL_UPGRADE_BONUS: 1.2,
		RAND_MIN: 1,
		RAND_MAX: 1.2,
		SUPER_CLICKERS_CHANCE: 0.4,
		SUPER_CLICKERS_MIN: 5,
		SUPER_CLICKERS_MAX: 7,
		SPECIAL_SUPER_CLICKERS_MIN: 10,
		SPECIAL_SUPER_CLICKERS_MAX: 15,
		SPECIAL_GEMS_MIN: 5,
		SPECIAL_GEMS_MAX: 5,
	},
};

export type ChestConfig = typeof CHEST_CONFIG_A;

//metóda je upravená po vyhodnotený A/B testu tak, aby sme zachovali rýchlu návratnosť do pôvodného stavu
export function getChestConfig(group: string | null): ChestConfig {
	return group === "B" ? CHEST_CONFIG_B : CHEST_CONFIG_B;
}

// Pre spätnú kompatibilitu
export const CHEST_CONFIG: ChestConfig = CHEST_CONFIG_B;
